import { FC } from 'app/FunctionalComponent'
import React from 'react'
import styles from './Center.module.scss'

const Center: FC = (props: { children: React.ReactNode }) => {
	return <div className={styles.center}>{props.children}</div>
}

export { Center }
